import APIService from '../base'
import type { AxiosResponse } from 'axios'
import type {
  ChangePasswordRequest,
  LoginRequest,
  LoginResponse,
} from '@/types/auth'

export class AuthService {
  static login(data: LoginRequest): Promise<AxiosResponse<LoginResponse>> {
    return APIService.post('/v1/auth/admin-login', data)
  }

  static refreshToken(): Promise<AxiosResponse<LoginResponse>> {
    return APIService.post('/v1/auth/refresh')
  }

  static generate2faUri(): Promise<
    AxiosResponse<{ otpAuthUrl: string; secret: string }>
  > {
    return APIService.post('/v1/auth/2fa/generate')
  }

  static enable2fa(
    code: string,
  ): Promise<AxiosResponse<{ recoveryCodes: string[] }>> {
    return APIService.post('/v1/auth/2fa/enable', { code })
  }

  static disable2fa(password: string): Promise<AxiosResponse<void>> {
    return APIService.post('/v1/auth/2fa/disable', { password })
  }

  static loginVerify2fa({
    challengeToken,
    code,
  }: {
    challengeToken: string
    code: string
  }): Promise<AxiosResponse<LoginResponse>> {
    return APIService.post('/v1/auth/2fa/verify', {
      challengeToken,
      code,
    })
  }

  static changePassword(
    payload: ChangePasswordRequest,
  ): Promise<AxiosResponse<void>> {
    return APIService.post('/v1/auth/change-password', payload)
  }
}
